import { mapActions } from 'vuex';
import { STANDART_TYPE, NOT_STANDART_TYPE, TYPE_LABLES_MAP, STATUS_LABELS_MAP, PENDING_REVIEW_STATUS } from "../../constants/network-join-application"

export default {
	components: {},
	props: {
		show: {
			type: Boolean
		},
		data: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			dialogVisible: false,
			ruleForm: {
				number: '',
				customer: '',
				objectAddress: '',
				objectName: '',
				typeJoin: STANDART_TYPE,
				status: PENDING_REVIEW_STATUS,
				registrationDate: new Date()
			},
			rules: {
				number: [
					{
						required: true,
						message: "Це поле є обов'язковим",
					},
				],
				customer: [
					{
						required: true,
						message: "Замовник є обов'язковим",
					},
				],
				objectAddress: [{ required: true, message: "Адреса об'єкта є обов'язковою" }],
				objectName: [{ required: true, message: "Назва об'єкта є обов'язковою" }],
				typeJoin: [{ required: true, message: "Тип приєднання є обов'язковим" }],
				registrationDate: [{ required: true, message: "Дата реєстрації заяви є обов'язковою" }],
			},
		}
	},
	computed: {
		joiningTypes() {
			return [
				{
					label: TYPE_LABLES_MAP[STANDART_TYPE],
					value: STANDART_TYPE
				},
				{
					label: TYPE_LABLES_MAP[NOT_STANDART_TYPE],
					value: NOT_STANDART_TYPE
				},
			]
		},
		applicationStatuses() {
			return Object.keys(STATUS_LABELS_MAP).map(status => ({
				label: STATUS_LABELS_MAP[status],
				value: status
			}))
		},
		isEdit() {
			return !!this.data._id
		}
	},
	watch: {
		show(val) {
			this.dialogVisible = val;
			if (this.$refs.ruleForm) {
				this.$refs.ruleForm.clearValidate();
			}
		},
		data: {
			handler(value) {
				this.ruleForm = value
			},
			deep: true
		}
	},
	methods: {
		...mapActions(['saveNetworkJoinApplication', 'updateNetworkJoinApplication', 'getNetworkJoinApplications', 'setRefresh']),
		resetFields() {
			this.$refs.ruleForm.resetFields();
			this.getNetworkJoinApplications();
			this.setRefresh(true);
			this.ruleForm.status = PENDING_REVIEW_STATUS;
			this.ruleForm.typeJoin = STANDART_TYPE;
		},
		submitForm() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					if (!this.isEdit) {
						this.saveNetworkJoinApplication(this.ruleForm)
						.then(() => {
							this.$emit('update:show', false);
							this.$notify.success({
								title: 'Успіх',
								message: 'Заяву успішно створено!',
							});
							this.resetFields();
						})
						.catch(() => {
							this.$notify.error({
								title: 'Помилка!',
								message: "Сталася помилка під час створення заяви.",
							});
						});
					} else {
						const { _id, ...application} = this.ruleForm
						this.updateNetworkJoinApplication({
							id: _id,
							data:application
						}).then(() => {
							this.$emit('update:show', false);
							this.$notify.success({
								title: 'Успіх',
								message: 'Заяву успішно оновлено!',
							});
							this.resetFields();
						})
						.catch(() => {
							this.$notify.error({
								title: 'Помилка!',
								message: "Сталася помилка під час оновлення заяви.",
							});
						});
					}
				} else {
					return false;
				}
			});
		},
	},
}